/// <amd-module name="Test/TestPlansHubRefresh/TestCaseLinkedItems/Constants" />
export const TitleColumnId: string = "title";
export const PlanColumnId: string = "plan";
export const ProjectColumnId: string = "project";
export const TestSuitesTabId: string = "test-suites";
export const RequirementsTabId: string = "linked-requirements";
export const BugsTabId: string = "linked-bugs";
export const WorkItemIdColumnId: string = "id";
export const AssignedToColumnId: string = "assignedTo";
export const StateColumnId: string = "state";
export const LatestUpdateColumnId: string = "latestUpdate";
export const Title: string = "System.Title";
export const Id: string = "System.Id";
export const AssignedTo: string = "System.AssignedTo";
export const State: string = "System.State";
export const ChangedDate: string = "System.ChangedDate";
export const WorkItemType: string = "System.WorkItemType";
export const WorkItemCategoriesForBugsTab: string[] = ["Issue", "Bug"];
export const WorkItemCategoriesForRequirementsTab: string[] = [
    "User Story",
    "Epic",
    "Task",
    "Feature",
    "Requirement",
    "Review",
    "Risk",
    "Change Request",
    "Impediment",
    "Product Backlog Item"
];
export const WorkItemIconClassNameMap: { [workItemType: string]: string } = {
    "Issue": "bowtie-symbol-issue workitemicon-issue",
    "Bug": "bowtie-symbol-bug workitemicon-bug",
    "Task": "bowtie-symbol-task workitemicon-task",
    "Epic": "bowtie-symbol-crown workitemicon-epic",
    "User Story": "bowtie-symbol-book workitemicon-story",
    "Feature": "bowtie-symbol-trophy workitemicon-feature",
    "Requirement": "bowtie-symbol-stickynote workitemicon-requirement",
    "Review": "bowtie-symbol-review workitemicon-review",
    "Risk": "bowtie-symbol-flame workitemicon-risk",
    "Change Request": "bowtie-symbol-ask workitemicon-change-request",
    "Impediment": "bowtie-symbol-impediment workitemicon-impediment",
    "Product Backlog Item": "bowtie-symbol-list workitemicon-backlog-item"
};
export const WorkItemTypeReferenceNamesForBugsTab: string[] = [
    "Microsoft.VSTS.WorkItemTypes.Issue",
    "Microsoft.VSTS.WorkItemTypes.Bug"
];
export const WorkItemTypeReferenceNamesForRequirementsTab: string[] = [
    "Microsoft.VSTS.WorkItemTypes.UserStory",
    "Microsoft.VSTS.WorkItemTypes.Epic",
    "Microsoft.VSTS.WorkItemTypes.Task",
    "Microsoft.VSTS.WorkItemTypes.Feature",
    "Microsoft.VSTS.WorkItemTypes.Requirement",
    "Microsoft.VSTS.WorkItemTypes.Impediment",
    "Microsoft.VSTS.WorkItemTypes.ProductBacklogItem",
    "AzureDevOps.DCR",
    "Microsoft.VSTS.WorkItemTypes.CodeReviewRequest"
];
export const LinkedPanelLastSelectedTab = "LinkedPanelLastSelectedTab";
export const WorkItemBatchSize = 200;
